import { render, staticRenderFns } from "./EditCase2.vue?vue&type=template&id=2cc10eea&scoped=true"
import script from "./EditCase2.vue?vue&type=script&lang=js"
export * from "./EditCase2.vue?vue&type=script&lang=js"
import style0 from "./EditCase2.vue?vue&type=style&index=0&id=2cc10eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc10eea",
  null
  
)

export default component.exports